// extracted by mini-css-extract-plugin
export default {"RecipientListContainer":"_RecipientListContainer--PSaoF","ListTitle":"_ListTitle--LEseW"};